export default "__VITE_ASSET__DFtm3JaT__"